(function () {
    'use strict';

    angular.module("caffeprint")
        .directive('cpMultiselectTwoSides', cpMultiselectTwoSides);

    cpMultiselectTwoSides.$inject = ['lodashService'];

    function cpMultiselectTwoSides(lodashService) {

        return {
            restrict: 'E',
            templateUrl: 'app/caffeprint/directives/multiselect-two-sides/multiselect-two-sides.html',
            replace: true,
            scope: {
                object: '=',
                modelProp: '@',
                propTitle: '@',
                propValue: '@',
                options: '='
            },
            link: function (scope, element, attrs, controller) {
                scope.optionsModel = [];

                scope.$watch('options', function () {
                    scope.optionsModel = lodashService.differenceWith(scope.options, scope.object[scope.modelProp],  function (option1, option2) {
                        return option1[scope.propValue] === option2;
                    });
                });

                scope.settings = {
                    search: {
                        left: '<input type="text" name="q" class="form-control" placeholder="Filtruj!" />',
                        right: '<input type="text" name="q" class="form-control" placeholder="Filtruj!" />'
                    },
                    fireSearch: function(value) {
                        return value.length >= 1;
                    },
                    keepRenderingSort: true,
                    sort: false,
                    submitAllLeft: false,
                    right: '#js_multiselect_to_1',
                    rightAll: '#js_right_All_1',
                    rightSelected: '#js_right_Selected_1',
                    leftSelected: '#js_left_Selected_1',
                    leftAll: '#js_left_All_1',
                    moveUp: '#multiselect_move_up',
                    moveDown: '#multiselect_move_down',
                    beforeMoveToRight: beforeMoveToRight,
                    beforeMoveToLeft: beforeMoveToLeft
                };

                element.find(".js-multiselect").multiselect(scope.settings);

                angular.element('#multiselect_move_up').click(onReorder);
                angular.element('#multiselect_move_down').click(onReorder);

                function beforeMoveToRight($left, $right, $options) {
                    angular.forEach($options, function (newOption) {
                        var optionModel = angular.element(newOption).scope().option;
                        scope.object[scope.prop].push(optionModel);
                        lodashService.remove(scope.optionsModel, optionModel);
                        scope.$apply();
                    });
                    return false;
                }

                function beforeMoveToLeft($left, $right, $options) {
                    angular.forEach($options, function (newOption) {
                        var optionModel = angular.element(newOption).scope().option;
                        scope.optionsModel.push(optionModel);
                        lodashService.remove(scope.object[scope.prop], optionModel);
                        scope.$apply();
                    });
                    return false;
                }

                function onReorder(e) {
                    var options = angular.element("#js_multiselect_to_1").children();
                    angular.forEach(options, function (option) {
                        var optionElement = angular.element(option),
                            optionModel = optionElement.scope().option;

                        optionModel.position = optionElement.index();
                        scope.$apply();
                    });
                }
            }
        };
    }
})();
